module.exports = __webpack_public_path__ + "img/overview_look_pic.9eedca01.png";